export default __webpack_public_path__ + "static/media/tree-5076.addcac32.png";